import { useTranslation } from "react-i18next";

const BUCKET_KEYS = ["noEvaluation", "bucketRecommended", "bucketToReview", "bucketLow", "bucketVeryLow", "bucketDisqualified", "bucketNeedsReview"];

export default function useScoreLabels() {
    const { t } = useTranslation("models");
    const labels = Object.fromEntries(BUCKET_KEYS.map((k) => [k, t(`scoreLabels.${k}`)]));
    const aiLevel = (level) => {
        const key = String(level ?? "unknown").replace(/_/g, "").toLowerCase();
        return t(`scoreLabels.${key}`, { defaultValue: String(level ?? "—") });
    };
    return { labels, aiLevel, t };
}
